import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';


function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsMenuOpen(false);
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <nav className="bg-transparent text-white fixed w-full z-50">
            <div className="container mx-auto px-4">
                <div className="flex justify-end items-center h-16 tracking-wider">

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden p-2"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                            />
                        </svg>
                    </button>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex space-x-12 tracking-wider">
                        <Link to="/" className="hover:text-gray-300">Home</Link>
                        <Link to="/services" className="hover:text-gray-300">Services</Link>
                        <Link to="/ladies" className="hover:text-gray-300">Girls</Link>
                        <Link to="/contact" className="hover:text-gray-300">Contact</Link>
                    </div>
                </div>

                {/* Mobile Menu with Background */}
                {isMenuOpen && (
                    <div className="md:hidden py-4 bg-gray-900 rounded-lg mt-2">
                        <div className="flex flex-col space-y-8 px-4 text-xl">
                            <Link to="/" className="hover:text-gray-300">Home</Link>
                            <Link to="/services" className="hover:text-gray-300">Services</Link>
                            <Link to="/ladies" className="hover:text-gray-300">Girls</Link>
                            <Link to="/contact" className="hover:text-gray-300">Contact</Link>
                        </div>
                    </div>
                )}
            </div>
        </nav>
    );
}

export default Navbar;